<kiss-table-header>
  <ng-container kissHeaderRowOutlet></ng-container>
</kiss-table-header>

<kiss-table-body>
  <ng-container kissRowOutlet></ng-container>
</kiss-table-body>
